// Constants for field groups in OTMM.

export const NOMINATIONS_FG = 'DISMD.CATEGORY.CRWS.NOMINATIONS';
export const BEST_PRACTICE_FG = 'DE.CATEGORY.BEST_PRACTICE';
export const LESSONS_LEARNED_HL_FG = 'DE.CATEGORY.LESSONS_LEARNED_HL';
export const REVIEW_PROCESS_FG = 'CRWS.TABLE.REVIEW_PROCESS_UI';
